import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FetchPolicy } from 'react-relay';

export interface ISettingState {
    updateSettingFetchKey: number;
    updateTaskFetchKey: number;
    updateScheduleItemFetchKey: number;
    fetchPolicy?: FetchPolicy | null;
}

const initialState: ISettingState = {
    updateSettingFetchKey: 0,
    updateTaskFetchKey: 0,
    updateScheduleItemFetchKey: 0,
};

export const settingSlice = createSlice({
    name: 'settingSlice',
    initialState,
    reducers: {
        setterSetting: (state, action: PayloadAction<Partial<ISettingState>>) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        changeUpdateSettingFetchKey: (state) => {
            return {
                ...state,
                updateSettingFetchKey: state.updateSettingFetchKey + 1,
            };
        },
        changeUpdateTaskFetchKeyWithPolicy: (state, action: PayloadAction<Partial<ISettingState>>) => {
            const { fetchPolicy } = action.payload ?? {};
            return {
                ...state,
                fetchPolicy,
                updateTaskFetchKey: state.updateTaskFetchKey + 1,
            };
        },
        changeUpdateTaskFetchKey: (state) => {
            return {
                ...state,
                updateTaskFetchKey: state.updateTaskFetchKey + 1,
            };
        },
        changeUpdateScheduleFetchKeyWithPolicy: (state, action: PayloadAction<Partial<ISettingState>>) => {
            const { fetchPolicy } = action.payload ?? {};
            return {
                ...state,
                fetchPolicy,
                updateScheduleItemFetchKey: state.updateScheduleItemFetchKey + 1,
            };
        },
        changeUpdateScheduleFetchKey: (state) => {
            return {
                ...state,
                updateScheduleItemFetchKey: state.updateScheduleItemFetchKey + 1,
            };
        },
    },
});

export const {
    setterSetting,
    changeUpdateSettingFetchKey,
    changeUpdateTaskFetchKey,
    changeUpdateScheduleFetchKey,
    changeUpdateScheduleFetchKeyWithPolicy,
    changeUpdateTaskFetchKeyWithPolicy,
} = settingSlice.actions;

export default settingSlice.reducer;
